import { Avatar, Box, Button, createStyles, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React from "react";
import { Mentor, Order } from "../../../Shared/GeneratedTypes";
import { Localizations } from "../../../Shared/sharedTypes";
import Util from "../../../Shared/utilties";

interface propsType {
    beginSession: () => void;

    order: Order;
    mentor: Mentor;
    localizations: Localizations;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: "auto",
            position: "relative",
            width: "85%",
            paddingTop: "85%",
            "& > img": {
                position: "absolute",
                top: 0,
            },
        },
    })
);

export default function MeetYourMentor({ mentor, order, beginSession, localizations }: propsType) {
    const classes = useStyles();
    return (
        <>
            <Grid
                item
                className="transparentBackground"
                container
                style={{ flex: 1, backgroundColor: "#85C441AA", padding: "24px 24px" }}
            >
                <Box p={2} borderRadius={10} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                    <img
                        src={order.logoPhotoUrl}
                        alt="carrier logo"
                        style={{
                            marginTop: 12,
                            marginBottom: 12,
                            maxHeight: "100px",
                            maxWidth: "80%",
                        }}
                    />

                    <Typography style={{ fontSize: "1.2em", lineHeight: "1.3em", color: "#000" }}>
                        {Util.format(localizations.mentorSalutation, {
                            firstName: mentor.firstName,
                            lastName: mentor.title ? `${mentor.lastName} - ${mentor.title}` : mentor.lastName,
                        })}
                        <br />
                        {localizations.clickToBeginYourSession}
                    </Typography>
                    <Box m={3} textAlign="center">
                        <Avatar alt="Self portrait" src={mentor.photoUrl} className={classes.root}></Avatar>
                    </Box>

                    <Button
                        style={{}}
                        variant="contained"
                        size="large"
                        color="primary"
                        fullWidth
                        onClick={beginSession}
                    >
                        {localizations.startVideo}
                    </Button>
                </Box>
            </Grid>
        </>
    );
}
